export default {
  accessApiBaseUrl: 'https://access.pcgec.qq.com',
  apiBaseUrl: 'https://spider.qq.com/post/f1bf5fda4ff057588ad61262633454f7',
  newApiBaseUrl: 'https://router.pcgec.qq.com',
  loginUrl: 'https://eshop.qq.com/index.html#/login',
  entracePage: 'https://eshop.qq.com/index.html',
  userCenterPage: 'https://eshop.qq.com/index.html#/userCenter',
  invitePage: 'https://eshop.qq.com/index.html#/invite',
  mobileBindMediaPage: 'https://eshop.qq.com/index.html#/mobile/mediaBind',
  mobileConfirmBindPage: 'https://eshop.qq.com/index.html#/mobile/confirmBind',
  mobileConfirmBindQqPage: 'https://eshop.qq.com/#/mobile/confirmBind/qq', // QQ回调地址，这个地址不能随便改，需要在QQ互联平台添加回调地址白名单
  authWXRedirectUrl: 'https://eshop.qq.com/index.html#/transfer',
  authRedirectUrl: 'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101856298&redirect_uri=https%3a%2f%2feshop.qq.com%2f%23%2ftransfer', // QQ鉴权回调地址，这个地址不能随便改，需要在QQ互联平台添加回调地址白名单
  xeppRegister: 'https://seller.txshop.qq.com/dist/boss.html#/login?from_app=eshop&reg_phone=',
  saasApply: 'https://eshop.qq.com/apply',
};
